<template>
  <div class="top-up-admin">
    <div style="padding-top: 20px;">
      <p>{{ $t('bank') }}</p>
      <md-input-item
        v-model="bankInfo.bankShortName"
        readonly
        is-title-latent
        :placeholder="$t('bank')"
        @focus="isBankSelectorShow = true"
      >
        <img
          v-if="bankInfo.bankNo"
          slot="left"
          class="icon_svg"
          :src="getIconByCode(bankInfo.bankNo)"
          alt="bank-icon"
        >
        <span
          slot="right"
          class="right_tig"
        >
          <svg-icon class="nav_svg" name="chevron-right" />
        </span>
      </md-input-item>

      <!-- 银行列表 -->
      <BankList
        v-model="isBankSelectorShow"
        :data="BankListData"
        :bank-info="bankInfo"
        @selectBank="selectBank"
      />
    </div>

    <!-- 金额键盘和输入框 -->
    <FinancialNumberKeyboard
      v-model="money"
      :error.sync="moneyErrorMessage"
    />
    <div class="transaction-button">
      <md-button type="primary" :inactive="inactive" @click="topUpHandel">
        {{ $t('confirm') }}
      </md-button>
    </div>
    <!-- 支付键盘 -->
    <PasswordPopup
      v-model="passwordVisiable"
      :code.sync="password"
      :error.sync="passwordError"
      @finished="confirmMethod"
    />
    <!-- 控制支付loading -->
    <PayLoading :is-show="isShow" />
  </div>
</template>

<script>
import { Button, Toast, Field, CellItem, InputItem } from 'mand-mobile'
import FinancialNumberKeyboard from '@/components/FinancialNumberKeyboard'
import PasswordPopup from '@/components/PasswordPopup'
import PayLoading from '@/components/PayLoading'
import BankList from '@/components/BankList'
import { limitAmount } from '@/api/withdraw'
import { topUp, tradeDetail } from '@/api/topUp'
import { formatAmount } from '@/utils/format-amount'
import {
  TRADE_TYPE,
  ERROR_REQ_CODE,
  TRADE_TITLE,
  TRANSACTION_STATUS
} from '@/constants'
import fenToYuan from '@/utils/fen-to-yuan'
import yuanToFen from '@/utils/yuan-to-fen'
import { getIconByCode } from '@flash/fin-logo'
import { BankListData } from './banklist'
export default {
  name: 'TopUpAdmin',
  components: {
    FinancialNumberKeyboard,
    PasswordPopup,
    PayLoading,
    BankList,
    [InputItem.name]: InputItem,
    [Button.name]: Button,
    [Field.name]: Field,
    [CellItem.name]: CellItem
  },
  data () {
    return {
      TRADE_TYPE,
      getIconByCode,
      BankListData,
      bankInfo: {
        id: '002',
        bankNo: '104003',
        bankName: 'Bank Rakyat Indonesia',
        bankShortName: 'BRI'
      }, // 卡信息
      money: '',
      moneyErrorMessage: '', // 校验金额错误信息
      password: '', // 密码
      passwordVisiable: false, // 密码键盘
      passwordError: '', // 密码报错提示信息
      limitAmount: '', // 充值限额钱数
      isShow: false,
      sendMoney: '',
      activePayWay: '2',
      isBankSelectorShow: false
    }
  },
  computed: {
    // 提交按钮是否禁用
    inactive () {
      return !(this.moneyErrorMessage === '' && this.bankInfo.bankNo && this.money)
    }
  },
  watch: {
    money (value) {
      if (+value <= 0) {
        // 金额不能小于0元
        this.moneyErrorMessage = this.$t('more_amount') + ' Rp0.00' // ' Amount cannot be less than Rp0.00 '
      } else if (+value < 1) {
        // 金额不能小于50元
        this.moneyErrorMessage = this.$t('more_amount') + ' Rp1.00' // 'Amount cannot be less than Rp50.00'
      } else if (this.limitAmount && +value > this.limitAmount) {
        this.moneyErrorMessage = `${this.$t('less_amount_message')}${formatAmount(
            this.limitAmount
        )}` // less_amount_message
      } else {
        this.moneyErrorMessage = ''
      }
    }
  },
  created () {
    this.getLimitAmount() // 限额
  },
  destroyed () {
    this.clearInterval()
  },
  methods: {
    selectBank (option) {
      // 被选取卡的信息
      this.bankInfo = option
    },
    async getLimitAmount () {
      // 充值限额
      const { limitAmount: amount } = await limitAmount({
        payProductCode: TRADE_TITLE.TopUpAdmin
      })
      if (amount) this.limitAmount = fenToYuan(amount)
    },
    async topUpHandel () {
      // 充值按钮
      this.passwordVisiable = true // 密码键盘弹起
    },
    async confirmMethod (password) {
      const { code } = this.$route.query
      try {
        this.isShow = true // 支付loading弹起
        this.passwordVisiable = false
        this.inactive = true // 充值按钮置灰
        const res = await topUp({
          password,
          amount: yuanToFen(this.sendMoney) || yuanToFen(this.money),
          bankAccessToken: code,
          wayType: this.activePayWay,
          bankNo: this.bankInfo.bankNo
        }) // 键盘密码接口
        if (this.activePayWay === '0') {
          this.tradeNo = res.tradeNo // 定时器中用到的参数
          this.createInterval()
        } else {
          const { paymentAmount, ref1 } = res
          this.$router.push({ name: 'PaymentInfo', query: { amount: paymentAmount, ref1, bankNo: this.bankInfo.bankNo, bankName: this.bankInfo.bankShortName } })
        }
      } catch (e) {
        this.isShow = false
        this.passwordVisiable = false // 键盘隐藏
        this.inactive = false // 充值高亮
        if (e.code === ERROR_REQ_CODE.passError) {
          // 密码错误
          this.passwordVisiable = true // 键盘显示
          this.passwordError = e.message
        } else {
          e.code && Toast.failed(e.message, 4000, null, document.body, true)
        }
      } finally {
        this.inactive = false
        this.isShow = false
      }
    },
    async queryTradeDetail (tradeNo, countdown) {
      const { status } = await tradeDetail({ tradeNo }, (cancel) => {
        this.peddingCancel = cancel
      })
      // 交易订单状态 0:等待交易 1:银行受理中 2:银行处理中 3:交易成功 4:交易失败 5:超时交易关闭
      if (
        status === TRANSACTION_STATUS.pend ||
          status === TRANSACTION_STATUS.pending
      ) {
        // 银行受理中、银行处理中5S内继续请求
        this.peddingCancel = false
        if (countdown === 0) {
          // 5S内继续请求完后结果还是银行受理中或者银行处理中跳转到等待处理页面
          this.isShow = false
          this.$router.replace({
            name: 'HaveNoStepsDetail',
            query: { tradeNo, path: 'TopUpAdmin' }
          })
        }
      } else {
        // 清除定时器
        this.clearInterval()
        this.isShow = false
        this.$router.replace({
          name: 'HaveNoStepsDetail',
          query: { tradeNo, path: 'TopUpAdmin' }
        })
      }
    },
    clearInterval () {
      if (this.peddingCancel) {
        this.peddingCancel() // 终止请求
      }
      clearInterval(this.timer)
    },
    createInterval () {
      let countdown = 4
      const time = 1000
      this.timer = setInterval(() => {
        if (countdown <= 0) {
          this.isShow = false
          this.clearInterval()
        } else if (!this.peddingCancel) {
          countdown--
          this.queryTradeDetail(this.tradeNo, countdown)
        }
      }, time)
    }
  }
}
</script>

<style lang="scss" scoped>
.top-up-admin {
  height: 100%;
  padding: 0 40px;
}

.icon_svg {
  width: 64px;
  height: 64px;
  border-radius: 50%;
}
</style>
